import { useEffect } from "react";

import { useAnalytics } from "../../providers/AnalyticsProvider";
import { useFeatureFlags } from "../../providers/FeatureFlagProvider";
import { useAuthStore } from "../../stores/auth";
import { useShallow } from "zustand/shallow";

export function AnalyticsIdentity() {
  const analytics = useAnalytics();
  const { reload: reloadFeatureFlags } = useFeatureFlags();
  const { user, hydrated } = useAuthStore(useShallow((state) => ({ user: state.user, hydrated: state.hydrated })));

  useEffect(() => {
    if (!hydrated || !analytics.enabled) {
      return;
    }

    if (user) {
      // Only userId is sent for GDPR compliance - no email/PII in analytics
      analytics.identify(user.id);
      void reloadFeatureFlags();
    } else {
      analytics.reset();
    }
  }, [analytics, hydrated, user, reloadFeatureFlags]);

  return null;
}
